<mat-chip-listbox>
  @if (msg.tasks?.repost) {
    <mat-chip-option style="font-size: 11px"
    i18n="Post message item|label @@postMessageItem.repostChip">Репост: {{msg.tasks.repost.url}}</mat-chip-option>
  }
  @if (msg.tasks?.reply) {
    <mat-chip-option style="font-size: 11px"
    i18n="Post message item|label @@postMessageItem.replayChip">Ответ: {{msg.tasks.reply.url}}</mat-chip-option>
  }
</mat-chip-listbox>

<div class="image-wrap">
  @if (msg.type === types.Photo) {
    <img [src]="msg.file?.posterUrl" class="poster" />
  }
</div>


@if (msg.type === types.Animation) {
  <div class="video-preview">
    <video mat-card-image [src]="msg.file.publicUrl" preload="auto" controls loop></video>
  </div>
}

@if (msg.type === types.MediaGroup) {
  <div style="margin-bottom: 8px">
    @if (!msg.mediaGroupType || msg.mediaGroupType==='visual') {
      <div fxLayout="row wrap" fxLayoutGap="8px grid" class="grid"
        >
        @for (file of msg.files; track file) {
          <div fxFlex="50">
            <div>
              <img [src]="file.posterUrl" [alt]="file.filename" />
            </div>
          </div>
        }
      </div>
    }
    @if (msg.mediaGroupType && msg.mediaGroupType === 'audio') {
      <div>
        @for (file of msg.files; track file) {
          <div>
            @if (file.kind === 'audio') {
              <tg-audio-container [file]="file"></tg-audio-container>
            }
            @if (file.kind === 'voice') {
              <tg-voice-container [file]="file"></tg-voice-container>
            }
          </div>
        }
      </div>
    }
    @if (msg.mediaGroupType && msg.mediaGroupType === 'docs') {
      <div>
        @for (file of msg.files; track file) {
          <div>
            <tg-document-container [file]="file"></tg-document-container>
          </div>
        }
      </div>
    }
  </div>
}

@if (msg.type === types.Video || msg.type === types.VideoNote) {
  <tg-video-container [msg]="msg"
  [file]="msg.file"></tg-video-container>
}
@if (msg.type === types.Document) {
  <tg-document-container [file]="msg.file"></tg-document-container>
}
@if (msg.type === types.Audio) {
  <tg-audio-container [file]="msg.file"></tg-audio-container>
}
@if (msg.type === types.Voice) {
  <tg-voice-container [file]="msg.file"></tg-voice-container>
}

@if (msg.type === types.Sticker) {
  <i>Sticker</i>
  @if (isStickerAnimated) {
    <i> Animated</i>
  }
  <div class="sticker-wrap">
    <img [src]="msg.file.posterUrl" />
  </div>
}

<p
  #textItem
  style="white-space: pre-line; word-wrap: break-word"
  [hidden]="!text"
  class="post-text"
  [class.all]="!collapseText"
  [class.noAll]="msg.inTextPhotoUrl"
  [innerHtml]="text | quillRender"
></p>
@if (collapseText) {
  <div class="show-all" (click)="collapseText = !collapseText"
    i18n="Post message item|button @@postMessageItem.showAllText">Показать текст полностью ↓
</div>
}

@if (msg.inTextPhotoUrl) {
  <div class="text-image" fxLayout="row" fxLayoutAlign="start stretch">
    <div class="before-line"></div>
    @if (attachedPhotoFile) {
      <img class="in-text-photo" [src]="msg.inTextPhotoUrl | imageProxy" />
    }
    @if (!attachedPhotoFile) {
      <video class="in-text-photo" [src]="msg.inTextPhotoUrl | imageProxy"></video>
    }
  </div>
}

@if (msg.keyboard) {
  @for (item of msg.keyboard; track item; let i = $index) {
    <!--Links row Button-->
    @if (item && item.type === 'links-row') {
      <div
        class="links-block"
        fxLayout="row"
        fxLayoutGap="8px"
        [style.marginTop.px]="msg.inTextPhotoUrl || i > 0 ? 8 : 0"
        >
        @for (link of item.links; track link) {
          <a
            class="link-button"
            [href]="link.url"
            title="{{ link.text }}"
            target="_blank"
            >
            <span [innerHtml]="link.text | emojiInText"></span>
            <mat-icon class="right-icon">call_made</mat-icon>
          </a>
        }
      </div>
    }
    <!--END Link Button-->
    <!--Reaction Button-->
    @if (item && item.type === 'reaction') {
      <div class="reaction-block" fxLayout="row" fxLayoutGap="8px" [style.marginTop.px]="i > 0 ? 8 : 0">
        @for (reaction of item.reactions; track reaction) {
          <div class="reaction-item" [innerHtml]="reaction.text + ' ' + (reaction.count || '') | emojiInText"></div>
        }
      </div>
    }
    <!--END Reaction Button-->
    @if (item && item.type === 'hidden-text') {
      <div class="reaction-block" fxLayout="row" fxLayoutGap="8px" [style.marginTop.px]="i > 0 ? 8 : 0">
        @for (reaction of item.hiddenTextButtons; track reaction) {
          <div class="reaction-item" style="cursor: pointer" (click)="openPreviewHiddenText(reaction)">
            {{reaction.buttonText}}
            <mat-icon class="right-icon">read_more</mat-icon>
          </div>
        }
      </div>
    }
  }
}

@if (msg.answers) {
  @for (item of answersWithVotes; track item; let i = $index) {
    <span
      class="poll-button"
      [style.marginTop.px]="msg.inTextPhotoUrl || i > 0 ? 8 : 0"
      >
      <span [innerHtml]="item | emojiInText"></span>
      <mat-icon class="poll-icon">bar_chart</mat-icon>
    </span>
  }
}
